import { h } from './dom';

interface Lang { name: string; n: string; note: string; }

const LANGS: Lang[] = [
  { name: 'TypeScript', n: '01', note: '// type-safe end to end' },
  { name: 'Python',     n: '02', note: '// data, ML, scripting' },
  { name: 'Go',         n: '03', note: "// services that don't fall over" },
  { name: 'Rust',       n: '04', note: '// when it has to be fast' },
  { name: 'HTML/CSS',   n: '05', note: '// the platform, used well' },
];

function Word(l: Lang): HTMLElement {
  return h('span', { class: 's-stack__word' },
    l.name,
    h('span', { class: 'num' }, l.n),
    h('span', { class: 'note' }, l.note),
  );
}

export function Stack(): HTMLElement {
  const stack = h('div', { class: 's-stack' });
  LANGS.forEach((lang, i) => {
    stack.append(Word(lang));
    if (i < LANGS.length - 1) {
      stack.append(h('span', { class: 's-stack__sep' }, '/'));
    }
  });
  stack.append(h('span', { class: 's-stack__sub' },
    "We don't have a default stack. We have problems, and the languages that solve them. Hover any language above for the why.",
  ));

  const caption = h('div', { class: 's-section__caption' });
  caption.append('// 06 LANGUAGES', h('br'), 'FRONTEND · BACKEND · INFRA');

  const title = h('h2', { class: 's-section__title' });
  title.append('The right ', h('b', {}, 'tool.'), ' Used well.');

  return h('section', { id: 'stack', class: 's-section s-section--alt' },
    caption,
    h('header', { class: 's-section__head' },
      h('span', { class: 's-section__num' }, '02'),
      title,
    ),
    stack,
  );
}
